(function () {
  /* Sifariş düyməsi -> COD modal (modal yoxdursa adi checkout-a düşür) */
  function initCod(form) {
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (typeof window.openCodModal !== 'function') return;
      e.preventDefault();
      if (form.getAttribute('data-busy')) return;
      form.setAttribute('data-busy', '1');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var fd = new FormData(form);
      fd.delete('return_to');
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .catch(function () {})
        .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }); })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          form.removeAttribute('data-busy');
          if (typeof window.pmMetaTrackAddToCart === 'function') { try { window.pmMetaTrackAddToCart(); } catch (err) {} }
          window.openCodModal();
        })
        .catch(function () { form.removeAttribute('data-busy'); form.submit(); });
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-zd-ready')) return;
    root.setAttribute('data-zd-ready', '1');

    initCod(root.querySelector('form.zd-form'));

    var $ = function (sel) { return root.querySelector(sel); };
    var ctaBtn = $('[data-cta]');
    var sticky = $('[data-sticky]');
    var stickyBtn = $('[data-sticky-btn]');
    var track = $('[data-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');

    /* Sticky düymə əsas formu göndərir */
    if (stickyBtn && ctaBtn) {
      stickyBtn.addEventListener('click', function () { ctaBtn.click(); });
    }

    /* Seçim kartları: variant + göstərilən qiymətlər */
    var offers = root.querySelectorAll('[data-offer]');
    var variantInput = $('[data-variant-id]');
    function setText(sel, value) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.textContent = value || '';
        if (el.tagName === 'S') el.hidden = !value;
      });
    }
    function selectOffer(el) {
      offers.forEach(function (o) { o.classList.toggle('is-selected', o === el); });
      var input = el.querySelector('input');
      if (input && !input.checked) input.checked = true;
      if (variantInput) variantInput.value = el.getAttribute('data-variant');
      var price = el.getAttribute('data-price') || '';
      var old = el.getAttribute('data-compare') || '';
      setText('[data-price-now]', price);
      setText('[data-price-old]', old);
      setText('[data-cta-price]', price);
      setText('[data-sticky-now]', price);
      setText('[data-sticky-old]', old);
    }
    offers.forEach(function (o) {
      var input = o.querySelector('input');
      if (input) input.addEventListener('change', function () { if (input.checked) selectOffer(o); });
      if (input && input.checked) selectOffer(o);
    });

    /* Qalereya: thumb <-> scroll */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = track.children[Number(t.getAttribute('data-thumb'))];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    var raf;
    if (track) {
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        });
      }, { passive: true });
    }

    /* Sticky bar: əsas düymə görünməyəndə çıxır */
    if ('IntersectionObserver' in window && ctaBtn && sticky) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
      });
      io.observe(ctaBtn);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-zd-product]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-zd-product]') : null;
    if (r) init(r);
  });
})();
